import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types"
import i18n from 'i18n/index.js'
import { buildLocalePath } from "components/utils/Locale";
import HomeImage from "components/home/HomeImage"

const TIME_OPTIONS = [
  { key: 'half_day', imageUrl: 'half_day_url' },
  { key: 'full_day', imageUrl: 'full_day_url' },
  { key: 'multiple_days', imageUrl: 'multiple_days_url' }
]

function CarouselTimePreferences(props) {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000)
    return () => clearTimeout(timer)
  }, [])

  const renderTimeOption = ({ key, imageUrl }) => (
    <div className="carousel-time-preferences__time-option" key={key}>
      <div
        className="carousel-time-preferences__time-box"
        onClick={() => window.open(buildLocalePath(`products?time=${key}`), '_blank')}
      >
        <div className="carousel-time-preferences__image-container">
          <a
            href={buildLocalePath(`products?time=${key}`)}
            className="oi-stack-center"
            target="_blank"
            title="View Details"
            onClick={(e) => e.stopPropagation()}
          >
            <HomeImage
              home_class="margin-bt-7"
              image_url={props[imageUrl]}
              url={undefined}
              alt={key}
              height={102}
            />
          </a>
        </div>
        <div className="carousel-time-preferences__text-container">
          <span>
            {i18n.t(`excursions.${key}`)}
          </span>
        </div>
      </div>
    </div>
  )

  const renderLoadingSkeleton = () => (
    <div className="carousel-time-preferences__skeleton-container">
      {[1, 2, 3].map((item) => (
        <div className="carousel-time-preferences__skeleton-cell" key={item}>
          <div
            className="time-loader oi-skeleton oi-skeleton--wave oi-skeleton--rounded oi-w-full"
            style={{ height: 115 }}
            aria-hidden
          />
        </div>
      ))}
    </div>
  )

  return (
    <section className="caroussel">
      <section className="products-section">
        {loading ? renderLoadingSkeleton() : (
          <div className="carousel-time-preferences__container">
            {TIME_OPTIONS.map(renderTimeOption)}
          </div>
        )}
      </section>
    </section>
  )
}

CarouselTimePreferences.propTypes = {
  half_day_url: PropTypes.string.isRequired,
  full_day_url: PropTypes.string.isRequired,
  multiple_days_url: PropTypes.string.isRequired
}

export default CarouselTimePreferences
